import MainButton from "../../../components/Admin/MainButton/MainButton";
import Addteacherpopup from "../../../components/Admin/AddTeacherPopup";
import { popupContext } from "../../../contextAdmin/Admin/Popup/index";
import { useEffect, useContext, useState } from "react";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import NewTable from "../../../components/Admin/NewTable/NewTable";
import ButtonListClass from "../../../components/Admin/ButtonListClass/ButtonListClass";
import { userContext } from "../../../contextAdmin/Admin/User/index";
import { useNavigate } from "react-router-dom";

import styles from "./style.module.css";

import React from "react";
import adminRequets from "../../../components/api/adminRequests";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import { calcCurrList } from "../../../functions/pagination";

export default function AdminPermissionUi() {
  const { popUp, setPopup } = useContext(popupContext);
  const { headerTxt, setHeaderText } = useContext(HeaderTextContext);
  const { list, setList } = useContext(listControllerContext);


  const [itemsPerPage, setItemsPerPage] = useState(7)
  const [paginationData, setPaginationData] = useState(list && list.length ? calcCurrList(list, 1, 7) : { currentItems: [], totalPages: undefined, pageToShow: 1 })

  const { user } = useContext(userContext);



  useEffect(() => {
    if (!(user.permissions === "admin")) return NoPermission("/login");

    setHeaderText("admin");
    getAllHighLevelUsers()
  }, []);


  useEffect(() => {
    if (list.length) {
      let prevTotalPages = paginationData.totalPages;
      let CurrentToShow = calcCurrList(list, paginationData.pageToShow, itemsPerPage)
      if (prevTotalPages < CurrentToShow.totalPages) {
        console.log("🚀 ~ file: AdminPermissionUi.jsx:55 ~ useEffect ~ prevTotalPages < CurrentToShow.totalPages:", prevTotalPages, CurrentToShow.totalPages)
        //mean there is a new user - not working yetTODO:
        setPaginationData(CurrentToShow)
      } else {
        setPaginationData(CurrentToShow)

      }
      // let pageToShow = Math.ceil(list.length / itemsPerPage) > paginationData.totalPages ? paginationData.totalPages + 1 : paginationData.pageToShow//check if the new user is in new page

    }
  }, [list])

  useEffect(() => {
    if (list.length) {
      let CurrentToShow = calcCurrList(list, paginationData.pageToShow, itemsPerPage)
      setPaginationData(CurrentToShow)

    }
  }, [paginationData.pageToShow])





  async function getAllHighLevelUsers() {
    try {
      let list = await adminRequets.getAllTeachers()
      setList(list)
    } catch (error) {
      console.log("🚀 ~ file: AdminPermissionUi.jsx:31 ~ getAllHighLevelUsers ~ error:", error)
    }
  }


  const NoPermission = useNavigate();



  return (
    <div className={styles.container}>
      <MainButton
        onClick={() => {
          setPopup(<Addteacherpopup>Add Teacher</Addteacherpopup>);
        }}
      >
        Add New Teacher
      </MainButton>

      {/* </div> */}
      {paginationData.totalPages > 1 &&
        <div className={styles["buttonListClass"]}>
          <ButtonListClass
            totalPages={paginationData.totalPages}
            setPaginationData={setPaginationData}
            pageActive={paginationData.pageToShow}
          />
        </div>}
      <div className={styles["mainTable"]}>
        <NewTable currList={paginationData.currentItems} typ={"teacher"} />
      </div>

    </div>
  );
}
